export const homePath = "/dashboard/";

export const routes = {
  USERS: homePath + "users",
  CATEGORIES: homePath + "listing/categories",
  SUB_CATEGORIES: homePath + "listing/sub-categories",
  BRANDS: homePath + "listing/brands",
  PRODUCTS: homePath + "listing/products",
  GIFTS: homePath + "listing/gifts",
  CLASSIFICATIONS: homePath + "listing/classifications",
  CREATE_CATEGORY: homePath + "listing/categories/create",
  CREATE_SUB_CATEGORY: homePath + "listing/sub-categories/create",
  CREATE_BRAND: homePath + "listing/brands/create",
  CREATE_PRODUCT: homePath + "listing/products/create",
  CREATE_GIFT: homePath + "listing/gifts/create",
  CREATE_CLASSIFICATION: homePath + "listing/classifications/create",
  BANNERS: homePath + "banners",
  CREATE_BANNER: homePath + "banners/create",
  CREATE_SELECT: homePath + "selects/create",
  SELECTS: homePath + "selects",
  CREATE_PROMOTION: homePath + "promotions/offers/create",
  PROMOTIONS: homePath + "promotions/offers",
  DISCOUNTS: homePath + "promotions/discounts",
  COUPONS: homePath + "coupons",
  CREATE_COUPON: homePath + "coupons/create",
  BLOGS: homePath + "blogs",
  CREATE_BLOG: homePath + "blogs/create",
  PRODUCT_RATINGS: homePath + "ratings/products",
  EXPERIENCE_RATINGS: homePath + "ratings/experience",
  PENDING_ORDERS: homePath + "orders/pending",
  ACTIVE_ORDERS: homePath + "orders/active",
  HISTORY_ORDERS: homePath + "orders/history",
  RETURNS_REQUESTS: homePath + "orders/requests",
  PENDING_SUPPLIERS: homePath + "suppliers/pending",
  APPROVED_SUPPLIERS: homePath + "suppliers/approved",
  SUPPLIERS_ANALYTICS: homePath + "suppliers",
  ACCOUNTING: homePath + "accounting",
  DELIVERY_SETTLEMENT: homePath + "accounting/delivery-settlement",
  DELIVERY_STATEMENT: homePath + "accounting/delivery-statement",
  ACCOUNT_SETTLEMENT: homePath + "accounting/account-settlement",
  ACCOUNT_STATEMENT: homePath + "accounting/account-statement",
  PRODUCT_GROUPS: homePath + "product-groups",
  CREATE_PRODUCT_GROUP: homePath + "product-groups/create",
  INSURANCE_COMPANIES: homePath + "insurance-companies",
  CREATE_INSURANCE_COMPANY: homePath + "insurance-companies/create",
  USER_REPORT: homePath + "reports/users",
  ORDER_REPORT: homePath + "reports/orders",
  SUPPLIER_REPORT: homePath + "reports/suppliers",
  DELIVERY_REPORT: homePath + "reports/delivery",
  PRODUCT_REPORT: homePath + "reports/product",
  PUSH_NOTIFICATIONS: homePath + "notifications/push-notifications",
  NOTIFICATIONS_HISTORY: homePath + "notifications/notifications-history",
  SETTINGS: {
    GENERAL: homePath + "settings/general",
    SOCIAL: homePath + "settings/social",
    PROFILE: homePath + "settings/profile",
    GET_YOU_STARTED_TOUR: homePath + "settings/started-tour",
    MAP: homePath + "settings/map",
    NOTIFICATIONS: homePath + "settings/notifications",
    ABOUT_US: homePath + "settings/about-us",
    TERMS: homePath + "settings/terms",
    SHORT_TERMS: homePath + "settings/short-terms",
    PRIVACY: homePath + "settings/privacy",
    FAQ: homePath + "settings/faq",
    CANCELLATION_POLICY: homePath + "settings/cancellation-policy",
    DELIVERY_POLICY: homePath + "settings/delivery-policy",
    REFUND_POLICY: homePath + "settings/refund-policy",
    COOKIES_POLICY: homePath + "settings/cookies-policy",
    DEFAULT_OTP: homePath + "settings/default-otp",
  },
};

export const uniqueKeys = {
  USER_REPORT: "users",
  ORDER_REPORT: "orders",
  SUPPLIER_REPORT: "suppliers",
  DELIVERY_REPORT: "delivery",
  PRODUCT_REPORT: "product",
  CATEGORIES: "categories",
  SUB_CATEGORIES: "sub-categories",
  BRANDS: "brands",
  PRODUCTS: "products",
  GIFTS: "gifts",
  CLASSIFICATIONS: "classifications",
  ORDERS: "orders",
  PENDING: "pending",
  APPROVED: "approved",
  ACTIVE: "active",
  HISTORY: "history",
  SUPPLIERS: "suppliers",
  DRIVERS: "drivers",
  RETURNS_REQUESTS: "requests",
  DELIVERY_SETTLEMENT: "delivery-settlement",
  DELIVERY_STATEMENT: "delivery-statement",
  ACCOUNT_STATEMENT: "account-statement",
  ACCOUNT_SETTLEMENT: "account-settlement",
  PUSH_NOTIFICATIONS: "push-notifications",
  NOTIFICATIONS_HISTORY: "notifications-history",
  EXPERIENCE: "experience",
  OFFERS: "offers",
  DISCOUNTS: "discounts",
  SETTINGS: {
    GENERAL: "general",
    SOCIAL: "social",
    PROFILE: "profile",
    GET_YOU_STARTED_TOUR: "started-tour",
    MAP: "map",
    NOTIFICATIONS: "notifications",
    ABOUT_US: "about-us",
    TERMS: "terms",
    SHORT_TERMS: "short-terms",
    PRIVACY: "privacy",
    FAQ: "faq",
    CANCELLATION_POLICY: "cancellation-policy",
    DELIVERY_POLICY: "delivery-policy",
    REFUND_POLICY: "refund-policy",
    COOKIES_POLICY: "cookies-policy",
    DEFAULT_OTP: "default-otp",
  },
};

export const filters = {
  ORDERS: {
    pending: "pending",
    active:
      "processing,picked_up,accept_return,ready_for_pickup,being_collected",
    history: "refunded,rejected,delivered,cancelled,Order Picked Up",
    requests: "accept_return,reject_return,return_request",
  },
  SUPPLIERS: {
    pending: "pending",
    approved: "approved",
  },
};

export const allowedImages = ["image/png", "image/jpg", "image/jpeg"];
export const allowedVideos = ["video/mp4"];

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const roles = ["Customer", "Suppliers", ["Admin", "Super Admin"]];
